export default "__VITE_ASSET__w7j9cIPJ__"